import { useTranslation } from 'react-i18next'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import findTicketFormStore from 'entities/ticket/models/find-ticket/find-ticket-store'

import { FilterBar as SharedFilterBar } from 'shared/ui/filter-bar'
import type { FilterBarItem } from 'shared/ui/filter-bar'

import { getFilterActiveState } from '../lib/getFilterActiveState'
import { getFilterDisplayText } from '../lib/getFilterDisplayText'
import { FilterBarItems } from '../model'

export const FilterBar = observer(() => {
  const { t } = useTranslation()

  const filter = findTicketFormStore.formFindTicket?.filter
  const filterDataFromRequest = findTicketFormStore.dataForFilter

  const activeFilters = getFilterActiveState(filter, filterDataFromRequest)
  const displayTexts = getFilterDisplayText({
    filter,
    filterDataFromRequest,
    t,
  })

  const getIsFilterActive = (filterType: keyof typeof activeFilters) => {
    return activeFilters[filterType]
  }

  const getDisplayText = (
    filterType: keyof typeof displayTexts,
    fallbackTitle: string,
  ) => {
    const isActive = activeFilters[filterType]
    const displayText = displayTexts[filterType]

    if (isActive && displayText) {
      return displayText
    }
    return t(fallbackTitle)
  }

  const hasActiveFilters = Object.values(activeFilters).some(Boolean)

  const items: FilterBarItem[] = FilterBarItems.map((item) => {
    const filterType = item.title as keyof typeof activeFilters
    const isActive = getIsFilterActive(filterType)
    const displayText = getDisplayText(filterType, item.title)

    return {
      id: item.title,
      link: item.link,
      text: displayText,
      isActive,
    }
  })

  return (
    <SharedFilterBar
      items={items}
      filterLink={RoutingPaths.avia.filter.path()}
      showBadge={hasActiveFilters}
    />
  )
})
